const PUBLISHED_APP_ORIGIN = "https://grounded-cafe-finder.lovable.app";

/**
 * Returns a safe OAuth redirect URI across browser, preview, and native wrappers.
 * Native wrappers can sometimes expose non-public origins (e.g. localhost/custom schemes),
 * which Google rejects with "invalid_request".
 */
export function getOAuthRedirectUri(): string {
  try {
    const { origin, protocol, hostname } = window.location;
    const isHttp = protocol === "https:" || protocol === "http:";
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
    const isPreviewHost =
      hostname.endsWith(".lovableproject.com") ||
      (hostname.endsWith(".lovable.app") && hostname.startsWith("id-preview--"));

    if (isHttp && !isLocalhost && !isPreviewHost) {
      return origin;
    }
  } catch {
    // Fall back below
  }

  return PUBLISHED_APP_ORIGIN;
}

/**
 * Detect if app is running in a native iOS WebView shell (e.g. Despia/WKWebView).
 */
export function isNativeShell(): boolean {
  try {
    const ua = navigator.userAgent || "";
    const isAppleWebKit = /AppleWebKit/i.test(ua);
    const hasSafariToken = /Safari/i.test(ua);
    const isIOSDevice = /iPhone|iPad|iPod/i.test(ua);
    const isDespia = /Despia/i.test(ua);

    // WKWebView always exposes window.webkit.messageHandlers — most reliable signal.
    const hasWebKitBridge =
      typeof window !== "undefined" &&
      typeof (window as unknown as { webkit?: { messageHandlers?: unknown } }).webkit
        ?.messageHandlers !== "undefined";

    return (
      isDespia ||
      (isIOSDevice && hasWebKitBridge) ||
      (isIOSDevice && isAppleWebKit && !hasSafariToken)
    );
  } catch {
    return false;
  }
}

